import ReactGA from "react-ga";

// initialize
ReactGA.initialize("UA-145695892-1");

export function recordPageView(addition) {
  const parts = [window.location.pathname + window.location.search, addition];
  ReactGA.pageview(parts.join("-"));
}
